import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CreditUsageOverview } from '@nusign/picflow-backend-types';
import { PICFLOW_CONFIG } from '../picflow-config';
import { ObservableDataLoaderService } from './observable-data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class CreditService {
  private http = inject(HttpClient);
  private config = inject(PICFLOW_CONFIG);
  private dataLoader = inject(ObservableDataLoaderService);

  overview() {
    return this.dataLoader.get(
      'credits/usage/overview',
      () => this.http.get<CreditUsageOverview>(`${this.config.apiEndpoint}/credits/usage/overview`),
      1000 * 60,
      false
    );
  }
}
